import React from 'react'

export default function AboutPage() {
  return (
    <div>
      about 
    </div>
  )
}
